import { render, staticRenderFns } from "./InvoiceAddressSummary.vue?vue&type=template&id=21de6e43&scoped=true&"
import script from "./InvoiceAddressSummary.vue?vue&type=script&lang=js&"
export * from "./InvoiceAddressSummary.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceAddressSummary.vue?vue&type=style&index=0&id=21de6e43&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21de6e43",
  null
  
)

export default component.exports